import { Injectable } from '@angular/core'
import { FormGroup, Validators } from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  applyConfigToForm(
    formGroup: FormGroup,
    configMap: Map<string, string>,
    fieldIdToControlPathMap: { [key: string]: { path: string; isParent: boolean } }
  ) {
    configMap.forEach((value, fieldId) => {
      const controlPath = fieldIdToControlPathMap[fieldId]?.path
      if (!controlPath) return
      const isParent = fieldIdToControlPathMap[fieldId].isParent

      const control = formGroup.get(controlPath)
      if (!control) return

      const pathParts = controlPath.split('.')
      const controlName = pathParts.pop()
      const parentPath = pathParts.join('.')
      const parentGroup = parentPath ? formGroup.get(parentPath) : formGroup

      if (!controlName || !(parentGroup instanceof FormGroup)) return

      switch (value) {
        case 'MANDATORY': {
          control.addValidators(Validators.required)
          control.updateValueAndValidity()
          break
        }

        case 'VISIBLE':
        case 'OPTIONAL': {
          if (isParent) {
            const parentFormGroup = control as FormGroup
            Object.keys(parentFormGroup.controls).forEach(controlName => {
              const childControl = control.get(controlName)
              if (childControl) {
                childControl.removeValidators(Validators.required)
                childControl.updateValueAndValidity()
              }
            })
          } else {
            control.removeValidators(Validators.required)
            control.updateValueAndValidity()
          }

          break
        }

        case 'HIDDEN':
          parentGroup.removeControl(controlName)
          break
      }
    })
  }

  isFieldMandatory(configMap: Map<string, string>, fieldId: string): boolean {
    return configMap.get(fieldId) === 'MANDATORY'
  }

  isFieldHidden(configMap: Map<string, string>, fieldId: string): boolean {
    return configMap.get(fieldId) === 'HIDDEN'
  }

  isFieldOptional(configMap: Map<string, string>, fieldId: string): boolean {
    return configMap.get(fieldId) === 'OPTIONAL'
  }

  isFieldHiddenOrOptional(configMap: Map<string, string>, fieldId: string): boolean {
    return this.isFieldHidden(configMap, fieldId) || this.isFieldOptional(configMap, fieldId)
  }
}
